import {TrainingObjectiveDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'CREATE_CUSTOMER_CATEGORY';

export async function createTrainingObjective(
    userData: Record<string, string>,
    trainingObjective: Record<string, any>
) {
    try {
        const result = await TrainingObjectiveDao.createTrainingObjective(userData.userToken, trainingObjective);

        return result;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
